var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-shopify-page': _vm.isShopifyPage}},[(_vm.isMobile)?_c('ChangeModeNoteMobile',_vm._g(_vm._b({},'ChangeModeNoteMobile',_vm.changeModeNoteProps,false),_vm.changeModeNoteEmits)):_c('ChangeModeNoteDesktop',_vm._g(_vm._b({},'ChangeModeNoteDesktop',_vm.changeModeNoteProps,false),_vm.changeModeNoteEmits))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }